import { useCopyPasteHandlers } from './useCopyPasteHandlers';
import { useKeyboardKeyEvent } from '../WorkflowCanvas/hooks';
import { isPrimaryModifierPressed } from '../Search/helpers';
import { isTargetInputElement } from './helpers';
import { useCallback } from 'react';

type SnippetCopyPasteProps = {
  isCanvasFocused: boolean;
};

export default function SnippetCopyPaste({ isCanvasFocused }: SnippetCopyPasteProps) {
  const { handleCopy, handlePaste } = useCopyPasteHandlers();

  const canUseKeyboardEvent = useCallback((event: KeyboardEvent) => {
    if (!isPrimaryModifierPressed(event)) {
      return false;
    }

    if (!isCanvasFocused) {
      return false;
    }

    if (isTargetInputElement(event)) {
      return false;
    }

    return true;
  }, [isCanvasFocused]);

  useKeyboardKeyEvent('c', event => {
    if (!canUseKeyboardEvent(event)) {
      return;
    }
    handleCopy();
  });

  useKeyboardKeyEvent('v', event => {
    if (!canUseKeyboardEvent(event)) {
      return;
    }
    handlePaste();
  });

  return null;
}

